import { EntityFilters } from "src/pages/EntityFiltersPage/EntityList/types";
import { ZAttribute } from "src/types/ZAttribute";
import { ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";

export type ChildEntitiesRestriction = {
  attributeId: ZUid;
  valueId: ZUid;
};

type RestrictionSource = Pick<
  ZAttribute,
  "childDictionaryAttributeId" | "childDictionaryValueId"
>;

export const getChildEntitiesRestriction = ({
  childDictionaryAttributeId,
  childDictionaryValueId,
}: RestrictionSource): ChildEntitiesRestriction | undefined =>
  childDictionaryAttributeId != null && childDictionaryValueId != null
    ? {
        attributeId: childDictionaryAttributeId,
        valueId: childDictionaryValueId,
      }
    : undefined;

export const makeChildEntitiesRestrictionFilters = (
  restriction?: ChildEntitiesRestriction,
): Pick<EntityFilters, "attributeId" | "restrictionValues"> =>
  restriction
    ? {
        attributeId: restriction.attributeId,
        restrictionValues: [String(restriction.valueId)],
      }
    : {};

export const makeChildEntitiesInitialValues = (
  restriction?: ChildEntitiesRestriction,
): Record<string, string[]> =>
  restriction
    ? {
        [String(restriction.attributeId)]: [String(restriction.valueId)],
      }
    : {};

export const applyChildEntitiesRestriction = (
  entity: ZEntity,
  restriction?: ChildEntitiesRestriction,
): ZEntity => {
  if (!restriction) return entity;

  const attributeId = String(restriction.attributeId);
  const values = [String(restriction.valueId)];
  const index = entity.attributeValues.findIndex(
    (field) => String(field.attributeId) === attributeId,
  );
  const attributeValues = [...entity.attributeValues];
  const field = { attributeId: restriction.attributeId, values };

  if (index >= 0) {
    attributeValues[index] = { ...attributeValues[index], ...field };
  } else {
    attributeValues.push(field);
  }
  return { ...entity, attributeValues };
};
